import {
  PolicyCancelationMethod,
  PolicyCancelationReason,
  PolicyCancelationSource,
  PolicyReinstatementReason,
} from '@models/policyTransaction';

export const companyOptions = [
  { value: PolicyCancelationReason.CompanyRequest, label: 'Company Decision' },
  { value: PolicyCancelationReason.NonRenewal, label: 'Non-Renewal' },
];

export const insuredOptions = [
  { value: PolicyCancelationReason.InsuredRequest, label: 'Insured Request' },
  {
    value: PolicyCancelationReason.RewrittenToOtherCarrier,
    label: 'Rewritten by LIO',
  },
];

export const cancelationReasons = [...companyOptions, ...insuredOptions];

export const reinstatementReasons = [
  {
    value: PolicyReinstatementReason.UnderwritingDecision,
    label: 'Underwriting Decision',
  },
  { value: PolicyReinstatementReason.InsuredRequest, label: 'Insured Request' },
  { value: PolicyReinstatementReason.PremiumPaid, label: 'Premium Paid' },
  { value: PolicyReinstatementReason.Other, label: 'Other' },
];

export const cancelationMethods = [
  { value: PolicyCancelationMethod.ProRata, label: 'Pro-Rate' },
  { value: PolicyCancelationMethod.ShortRate, label: 'Short-Rate' },
  { value: PolicyCancelationMethod.Flat, label: 'Flat' },
];

/** Expired policies can only be cancelled at the insured's request */
export const expiredPolicyCancelationReasons = insuredOptions.filter(
  (option) => option.value === PolicyCancelationReason.InsuredRequest,
);

/** Flat cancellation is not allowed on expired policies */
export const expiredPolicyCancelationMethods = cancelationMethods.filter(
  (option) => option.value === PolicyCancelationMethod.ProRata || option.value === PolicyCancelationMethod.ShortRate,
);

export const cancelationSources = [
  { value: PolicyCancelationSource.Insured, label: 'Insured' },
  { value: PolicyCancelationSource.Company, label: 'Company' },
];
